const UMLAUT_LOOKUP = {
  ae: "ae",
  oe: "oe",
  ue: "ue",
  ss: "ss",
  ä: "ae",
  ö: "oe",
  ü: "ue",
  ß: "ss",
};

export function slugify(value) {
  return value
    .toLowerCase()
    .replace(/[äöüß]/g, (character) => UMLAUT_LOOKUP[character] || character)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function withLocale(path, locale) {
  return locale && locale !== "de" ? `/${locale}${path}` : path;
}

function ensureTrailingSlash(path) {
  return path.endsWith("/") ? path : `${path}/`;
}

export function getImagePagePath(image, locale) {
  if (locale && image.seoPaths?.[locale]) {
    return ensureTrailingSlash(image.seoPaths[locale]);
  }

  if (image.seoPath) {
    return ensureTrailingSlash(withLocale(image.seoPath, locale));
  }

  if (image.seoSlug) {
    return ensureTrailingSlash(withLocale(`/ausmalbild/${image.seoSlug}`, locale));
  }

  return ensureTrailingSlash(
    withLocale(`/view/${image.downloadUrl.replace(".png", "")}`, locale)
  );
}
